module.exports = __webpack_public_path__ + "img/chrome.273d152c.png";